(function () {
  const SOURCE_SELECTOR = '.p-codebuy__coordination_single_collection_list';
  const TARGET_SELECTOR = '.p-codebuy__coordination_single_description';
  const WRAPPER_CLASS = 'js-inserted-size-info';

  function buildText(source) {
    const items = source.querySelectorAll('.p-codebuy__coordination_single_collection_list_item');
    if (!items.length) return '';
    return Array.from(items)
      .map((item) => {
        const title = item.querySelector('.collection-title')?.textContent.trim() || '';
        const variant = item.querySelector('.collection-variant')?.textContent.trim() || '';
        return `${title}：${variant}`;
      })
      .join(' / ');
  }

  function syncSizeInfo() {
    const source = document.querySelector(SOURCE_SELECTOR);
    const target = document.querySelector(TARGET_SELECTOR);
    if (!source || !target) return;

    const text = buildText(source);
    if (!text) return;

    // target直後のwrapperが既にあるか確認(無ければ作る)
    let wrapper = target.nextElementSibling;
    if (!wrapper || !wrapper.classList.contains(WRAPPER_CLASS)) {
      wrapper = document.createElement('div');
      wrapper.className = WRAPPER_CLASS;
      wrapper.appendChild(document.createElement('span'));
      target.insertAdjacentElement('afterend', wrapper);
    }

    // 内容が変わっている時だけ更新(無駄なDOM書き換え・ループを防止)
    const span = wrapper.querySelector('span');
    if (span.textContent !== text) {
      span.textContent = text;
    }
  }

  // disconnectせず、監視し続ける
  const observer = new MutationObserver(syncSizeInfo);
  observer.observe(document.body, { childList: true, subtree: true });

  // スクリプト読み込み時点で既にモーダルが開いている場合の保険
  syncSizeInfo();
})();